<div class="d-flex justify-content-between align-items-center width-custom">
    <input class="form-control" [required]="to?.required" [formControl]="formControl" [class.is-invalid]="showError" [placeholder]="to?.placeholder"
        [type]="showPassword ? 'text' : 'password'" name="password">
        
        <i *ngIf="!showPassword" (click)="togglePasswordVisibility()" class="bi bi-eye-fill fs-3"></i>
        <i *ngIf="showPassword" (click)="togglePasswordVisibility()" class="bi bi-eye-slash-fill fs-3"></i>
</div>